(function($) {
	'use strict';

	$.widget('msv.simulator', {

		el: {
			simulatorItem: $('.js-simulator'),
			simulatorTotal: $('.js-simulator-total')
		},

		_init: function() {
			this._events()
		},

		_events: function() {
			var self = this;

			this.el.simulatorItem.not('[type=radio]').on('input', function() {
				setTimeout(function() {
					self._getData()
				}, 300)
			})

			this.element.find('.form-datalist__options').on('click', function() {
				self._getData()
			});

			this.element.find('[type=radio]').on('change', function() {
				if ($(this).prop("checked"))
					self._getData()
			})
		},

		_getData: function() {
			var self = this;

			$.ajax({
				type: 'GET',
				url: self.element.data('endpoint'),
				dataType: 'json',
				contentType: 'application/json',
				beforeSend: function() {
					self.element.find('button.btn').attr('disabled', true).addClass('btn-loading');
					self.element.find('.btn-loading').append("<span class='btn-loading-spinner'></span>");
				},
			}).done(function(data, textStatus, jqXHR) {
				self.element.find('button.btn').removeClass('btn-loading');
				self.element.find(".btn-loading-spinner").remove();
				if (jqXHR.status === 200) {

					var simulatorTotal =
						(self.element.find("[name=simulatorProductType]").val().length ? +self.element.find("[name=simulatorProductType]").attr('data-value') : 0) +
						(self.element.find("[name=simulatorInitialFee]").val().length ? +self.element.find("[name=simulatorInitialFee]").val() : 0) +
						(self.element.find("[name=days]:checked").length ? +$("[name=days]:checked").val() : 0)

					self.el.simulatorTotal.find('span span').html(simulatorTotal)
				}
			}).fail(function() {
				self.element.find('button.btn').attr('disabled', false).addClass('btn-red').removeClass('btn-loading');
				self.element.find(".btn-loading-spinner").remove();
			})
		}
	});

})(jQuery);